import React from "react";

export default function ViewLabel({
  title,
  scale,
  isActive,
  pxPerMm = 3,
}) {
  const fontSize = 3 * pxPerMm;
  const padX = 2.2 * pxPerMm;
  const padY = 1.2 * pxPerMm;
  const radius = 1.2 * pxPerMm;
  const left = 2 * pxPerMm;
  const top = 2 * pxPerMm;
  const borderWidth = Math.max(1, 0.18 * pxPerMm);

  return (
    <div
      style={{
        position: "absolute",
        left,
        top,
        zIndex: 30,
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          fontSize,
          lineHeight: 1,
          fontWeight: 700,
          padding: `${padY}px ${padX}px`,
          borderRadius: radius,
          border: `${borderWidth}px solid ${isActive ? "#1d4ed8" : "#e2e8f0"}`,
          background: isActive ? "#2563eb" : "rgba(255,255,255,0.92)",
          color: isActive ? "white" : "#334155",
          boxShadow: "0 1px 4px rgba(15,23,42,0.12)",
          whiteSpace: "nowrap",
        }}
      >
        {title}
        {scale ? (
          <span
            style={{
              marginLeft: 2 * pxPerMm,
              opacity: 0.8,
            }}
          >
            1:{scale}
          </span>
        ) : null}
      </div>
    </div>
  );
}